const rules = {
	// Usuario base sin rol específico
	user: {
		static: [
			"tickets:view-own",
			"messages:send",
			"contacts:view-own",
		],
	},

	// ADMINISTRADOR - Control total de la plataforma
	admin: {
		static: [
			"dashboard:view",
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"contacts-page:deleteContact",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection",
			"tickets-manager:closeAll",
			"apis:manage",
			"system:configure",
			"ai:configure-global",
			"plans:manage",
			"modules:activate",
			"companies:manage",
			"users:manage-all",
			"reports:view-all",
			"financial:view-all",
		],
	},

	// SUPERVISOR - Supervisa equipo de ventas
	supervisor: {
		static: [
			"dashboard:view",
			"reports:view-team",
			"analytics:view",
			"team:view",
			"leads:view-all",
			"users:view-team",
			"tickets:view-team",
		],
	},

	// VENDEDOR - Vende Klorum a empresas
	vendedor: {
		static: [
			"sales-dashboard:view",
			"leads:view",
			"leads:manage",
			"clients:create",
			"clients:register",
			"sales:manage",
			"commission:view",
			"ai:use-sales",
			"flows:create-sales",
			"tickets:view-own",
		],
	},

	// CLIENTE - Usa Klorum para su negocio
	cliente: {
		static: [
			"client-dashboard:view",
			"whatsapp:manage-own",
			"facebook:manage-own",
			"instagram:manage-own",
			"contacts:manage-own",
			"connections-page:addConnection",
			"connections-page:actionButtons",
			"connections-page:editOrDeleteConnection",
			"ai:configure-own",
			"flows:create-own",
			"campaigns:create-own",
			"tickets:view-own",
			"stats:view-own",
			"settings:manage-own",
			"users:manage-own-company",
		],
	},
};

export default rules;
